module.exports = __webpack_public_path__ + "img/alert.b39a9461.svg";